import styled, { css } from 'styled-components';
import { Hideable } from '@prisjakt/ui/hideable';
import { layout, media } from '@prisjakt/ui-base';

const paddingBottom = '5px';

type StickyPageHeaderProps = {
  showMobileSearchBar: boolean;
};

export const StickyPageHeader = styled(Hideable)<StickyPageHeaderProps>(
  props => css`
    flex-direction: column;
    position: sticky;
    top: ${layout.headerHeight.desktop.rem};
    background: ${props.theme.colors.base0};
    z-index: 3;
    box-shadow: 1px 3px 6px 0 rgba(0, 0, 0, 0.2);
    padding-bottom: ${paddingBottom};

    ${media.smallOnly`
      top: ${layout.headerHeight.mobile.rem};

      ${props.showMobileSearchBar &&
        css`
          top: ${layout.headerHeight.mobileWithSearch.rem};
        `}
    `}
  `
);
